//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyAccessService from '@/apps/data-platform/services/tables_views/my_access_service';
import SegmentTablesComponent from '@/apps/audiences/components/SegmentTablesComponent';
import firebase from 'firebase';
export default {
  name: 'AddAttributeMaster',
  components: {
    SegmentTablesComponent: SegmentTablesComponent
  },
  data: function data() {
    return {
      label: {
        name_es: this.translate('attributes.label.name_es'),
        name_en: this.translate('attributes.label.name_en'),
        description_es: this.translate('attributes.label.description_es'),
        description_en: this.translate('attributes.label.description_en'),
        attribute_object_name: 'tabla',
        alias: 'Alias'
      },
      form: {
        id: null,
        description_es: null,
        description_en: null,
        name_es: null,
        name_en: null,
        attribute_object_name: null,
        attribute_scheme_name: null,
        attribute_project_name: null,
        attribute_group_design: null,
        photoURL: null,
        alias: null,
        tech_alias: null
      },
      files: [],
      valid: false,
      // columns_selected: [],
      viewsData: [],
      tableSearch: {},
      serviceAccount: 'dev-itc-dp-bigquery-work@dev-intercorp-data-operation.iam.gserviceaccount.com',
      // isValidatingTable: false,
      // items: [],
      // partyId: null,
      // baseID: {},
      // keySearchTable: 1
      isLoadingProfile: false,
      isUploadingImage: false,
      selectedImage: null,
      uploadValue: 0,
      isUpdatingProfile: false
    };
  },
  created: function created() {
    //this.getObjectAccess()
  },
  methods: {
    onFileChanged: function onFileChanged(event) {
      this.selectedImage = event;
      this.form.photoURL = URL.createObjectURL(this.selectedImage);
    },
    onSubmit: function onSubmit(event) {
      var _this = this;
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      this.isUpdatingProfile = true;
      this.isUploadingImage = true;
      var uploadPromise = new Promise(function (resolve, reject) {
        if (_this.selectedImage) {
          var storageRef = firebase.storage().ref("attributes_marketplace/".concat(_this.selectedImage.name)).put(_this.selectedImage);
          storageRef.on('state_changed', function (snapshot) {
            _this.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            console.log(_this.uploadValue);
          }, function (error) {
            console.error(error.message);
          }, function () {
            _this.uploadValue = 100;
            storageRef.snapshot.ref.getDownloadURL().then(function (url) {
              console.log("Image url: ".concat(url));
              _this.isUploadingImage = false;
              _this.form.photoURL = url;
              _this.form.attribute_group_design = url;
              resolve();
            }).catch(function (error) {
              reject(error);
            });
          });
        } else {
          resolve();
        }
      });
      uploadPromise.then(function () {
        _this.form.tech_alias = _this.form.alias ? _this.form.alias.toLowerCase().trim().normalize("NFD") // separa acentos
        .replace(/[\u0300-\u036f]/g, "") // elimina acentos
        .replace(/[^\w\s-]/g, "") // elimina caracteres especiales excepto guiones y espacios.replace(/\s+/g, '_')
        .replace(/\s+/g, "_") : null;
        _this.$emit('SubmitMaster', _this.form);
      });
    },
    getObjectAccess: function getObjectAccess() {
      var _this2 = this;
      this.viewsData = [];
      var params = {
        user: this.serviceAccount
      };
      MyAccessService.getObjectAccess('attributes', params).then(function (response) {
        console.log(response);
        if (response && response.data) {
          response.data.forEach(function (element) {
            _this2.viewsData.push({
              text: element.table.id,
              value: element.view.projectId + '.' + element.view.datasetId + '.' + element.view.objectId,
              data: element
            });
          });
        }
      });
    },
    onTableSelected: function onTableSelected() {
      // console.log('tableSearch')
      // console.log(this.tableSearch)
      // console.log(this.tableSearch.data.table.datasetId)
      // console.log(this.tableSearch.data.table.objectId)
      // console.log(this.tableSearch.data.table.projectId)
      if (Object.keys(this.tableSearch).length > 0) {
        this.form.attribute_object_name = this.tableSearch.data.table.objectId;
        this.form.attribute_project_name = this.tableSearch.data.table.projectId;
        this.form.attribute_scheme_name = this.tableSearch.data.table.datasetId;
      }
      // if (this.viewsData.length > 0 && Object.keys(this.tableSearch).length > 0) {
      //   const params = {
      //     relativeResourceName: this.tableSearch.data.relativeResourceName,
      //     domain_table: this.tableSearch.data.domain
      //   }
      //   AssignmentsService.getListTagEntry(params)
      //     .then((response) => {
      //       if (response && response.code === 200) {
      //         console.log('---------------------')
      //         console.log(response)
      //         // const responseTPL = response.data
      //         // const tableTags = responseTPL.objects.tags
      //         // const columnTags = tableTags.filter(tag => !!tag.column)
      //         // this.items = columnTags
      //         // this.columns_selected = []
      //         // this.partyId = null
      //         // this.keySearchTable += 1
      //         // this.$refs.form.resetValidation()
      //       }
      //     })
      // }
    },
    validate: function validate() {
      return this.$refs.form.validate();
    }
  },
  computed: {
    rules: function rules() {
      var _this3 = this;
      return {
        name_es: [function (v) {
          return !!v || _this3.translate('reglas.nombre');
        }, function (v) {
          return v && v.length >= 3 || _this3.translate('reglas.nombre_min');
        }, function (v) {
          return v && v.length <= 50 || _this3.translate('reglas.nombre_max');
        }],
        description_es: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }, function (v) {
          return v && v.length >= 3 || _this3.translate('reglas.field_min');
        }, function (v) {
          return v && v.length <= 200 || _this3.translate('reglas.field_max');
        }],
        name_en: [function (v) {
          return !!v || _this3.translate('reglas.nombre');
        }, function (v) {
          return v && v.length >= 3 || _this3.translate('reglas.nombre_min');
        }, function (v) {
          return v && v.length <= 50 || _this3.translate('reglas.nombre_max');
        }],
        description_en: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }, function (v) {
          return v && v.length >= 3 || _this3.translate('reglas.field_min');
        }, function (v) {
          return v && v.length <= 200 || _this3.translate('reglas.field_max');
        }],
        alias: [function (v) {
          return !!v || _this3.translate('reglas.alias');
        }],
        attribute_group_design: [function (value) {
          return !value || value.size < 2000000 || 'Icon size should be less than 2 MB!';
        }],
        attribute_project_name: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }],
        attribute_scheme_name: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }],
        attribute_object_name: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }]
      };
    }
  }
};